






































































































import { Component, Vue } from 'vue-property-decorator';
import gql from 'graphql-tag';
import Loading from '@/components/Loading.vue';

@Component({
  components: {
    Loading,
  },
})
export default class LeaderboardView extends Vue {
  // bound to the <select>; empty string means national
  public centerCode: string = '';

  public centersQuery = gql`
    query Centers {
      centers {
        id
        centerCode
        name
      }
    }
  `;

  public leaderBoardQuery = gql`
    query LeaderBoard($centerCode: String) {
      leaderBoard(centerCode: $centerCode) {
        username
        homeCenter {
          name
          stateOrProvince
        }
        points
      }
    }
  `;
}
